export default __webpack_public_path__ + "static/media/7.792a7e43.jpg";